var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.languageData.labels !== undefined)?_c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('TopSection')],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',[_c('IncomeChart')],1),_c('v-row',[_c('LeftSection'),_c('RightSection')],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }